(function () {
  // Map of { [subscriptionVariantId]: sellingPlanId }
  // Any variant in here will be forced to include selling_plan
  // when Upcart tries to POST /cart/add.js?upcart=1...
  const FORCE_MAP = {
    // BALANCE
    "51974386843953": "691814105393", // balance 1 jar sub
    "51950055981361": "691810107697", // balance 3 jars sub
    "51950194557233": "691810140465", // balance 5 jars sub

    // PASSION
    "51972395204913": "691822166321", // passion 1 jar sub
    "51972395663665": "691822199089", // passion 3 jars sub
    "51972395925809": "691822231857", // passion 5 jars sub

    // BEAUTY
    "51972975165745": "691822985521", // beauty 1 jar sub
    "51972976017713": "691823018289", // beauty 3 jars sub
    "51972976476465": "691823051057"  // beauty 5 jars sub
  };

  // keep a reference to the real fetch
  const _origFetch = window.fetch;

  // monkey-patch fetch
  window.fetch = async function(input, init) {
    try {
      // get URL as string
      const url = (typeof input === 'string')
        ? input
        : (input && input.url ? input.url : '');

      // detect Upcart's "add to cart" call
      const isUpcartAdd =
        url.includes('/cart/add.js') &&
        url.includes('upcart=1') &&
        init &&
        init.method &&
        init.method.toUpperCase() === 'POST';

      if (!isUpcartAdd) {
        // not an Upcart add request, just send it through unchanged
        return _origFetch(input, init);
      }

      // Try to parse the JSON body Upcart is about to send
      let bodyObj;
      try {
        bodyObj = init && init.body ? JSON.parse(init.body) : null;
      } catch (err) {
        bodyObj = null;
      }

      if (
        bodyObj &&
        bodyObj.items &&
        Array.isArray(bodyObj.items) &&
        bodyObj.items.length > 0
      ) {
        bodyObj.items = bodyObj.items.map(item => {
          const vid = String(item.id);

          // If this variant is in FORCE_MAP, inject the matching selling_plan
          if (FORCE_MAP[vid]) {
            if (!item.quantity) {
              item.quantity = 1;
            }
            item.selling_plan = Number(FORCE_MAP[vid]);
            // Optional debug. You can leave this in or delete later.
            console.log(
              '[upsell-hack] injected selling_plan for variant',
              vid,
              '->',
              item.selling_plan
            );
          }

          return item;
        });

        // re-stringify with our injected selling_plan
        init.body = JSON.stringify(bodyObj);
      }

      const resp = await _origFetch(input, init);

      // Optional debug logging while you test. Safe to remove after.
      console.log('[upsell-hack] intercepted Upcart fetch', {
        url,
        status: resp.status
      });

      return resp;
    } catch (err) {
      console.error('[upsell-hack] fetch wrapper error', err);
      // fallback so we don't break cart if something throws
      return _origFetch(input, init);
    }
  };
})();